import { onMounted, onUnmounted, ref } from 'vue'

/**
 * A widget's own fullscreen toggle — the same technique already proven by
 * `OrganizationChart.vue` (a `position: fixed` cover, not a `DSDialog`):
 * the card is repositioned in place rather than torn down and remounted
 * elsewhere, so a chart's zoom, a grid's scroll position or sort state, and
 * anything else the widget holds internally survives the toggle. A real
 * Dialog would portal the content into a different part of the DOM, which
 * remounts it.
 */
export function useFullscreen() {
  const isFullscreen = ref(false)

  const toggle = () => {
    isFullscreen.value = !isFullscreen.value
  }

  const exit = () => {
    isFullscreen.value = false
  }

  const handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') exit()
  }

  onMounted(() => window.addEventListener('keydown', handleKeydown))
  onUnmounted(() => window.removeEventListener('keydown', handleKeydown))

  return { isFullscreen, toggle, exit }
}
